/********************************** C O R E **********************************/

//export const CONFIGURATION = '/:iTypecode/:sPaysCode/:sCode/:iMarqueId'
export const CONFIGURATION = '/:tokenCampaign/:color1?/:color2?/:isGlobal?'

export const ERROR = '/error'
export const INACTIVE_CAMPAIGN = '/inactive'

//Home
export const HOME = '/'

// For redirect to configurrtor at step funcing from tradein view
export const REDIRECT_TO_ROUTE = '/redirect/:id'
export const REDIRECT_TO_ROUTE_TRADEIN = '/redirect/1'
export const REDIRECT_TO_ROUTE_CONFIGURATOR_FUNDING = '/redirect/2'
export const REDIRECT_TO_ROUTE_STOCK_FUNDING = '/redirect/3'
export const REDIRECT_TO_ROUTE_CONFIGURATOR_FINALIZATION = '/redirect/4'
export const REDIRECT_TO_ROUTE_STOCK_FINALIZATION = '/redirect/5'

//CONFIGURATOR New car
export const CONFIGURATOR = '/new-car'
export const CONFIGURATOR_FUNDING = 'funding'
export const CONFIGURATOR_BRANDS = 'brands'
export const CONFIGURATOR_MODELS_GROUPS = 'models-groups'
export const CONFIGURATOR_MODELS = 'models'
export const CONFIGURATOR_FINISHES = 'trims'
export const CONFIGURATOR_MOTORS = 'motors'
export const CONFIGURATOR_DESIGN = 'design'
export const CONFIGURATOR_OPTIONS = 'options'
export const CONFIGURATOR_CONTRACTS = 'contracts'
export const CONFIGURATOR_CONGRATULATIONS = 'congratulations'
export const CONFIGURATOR_TRADEIN = 'tradeIn'
export const CONFIGURATOR_FINALIZATION = 'finalization'
export const REDIRECT_TO_CONFIGURATOR_FUNDING = '/new-car/funding'
export const REDIRECT_TO_CONFIGURATOR_FINALIZATION = '/new-car/finalization'

//CONFIGURATOR trade-in car
export const TRADEIN = '/trade-in'
export const TRADEIN_VEHICLE = 'vehicle'
export const TRADEIN_VEHICLE_CONFIRM = 'vehicle-confirm'
export const TRADEIN_COLORS = 'colors'
export const TRADEIN_OPTIONS = 'options'
export const TRADEIN_STATE = 'state'
export const TRADEIN_DEFAULTS = 'defaults'
export const TRADEIN_HISTORICAL = 'historical'
export const TRADEIN_DISTRIBUTOR = 'distributor'
export const TRADEIN_FUTHER_INFORMATIONS = 'futher-informations'
export const TRADEIN_CONTACT = 'contact'
export const TRADEIN_ESTIMATE = 'estimate'

//Stock
export const STOCK = '/stock'
export const STOCK_VEHICLES_LIST = 'vehicles-list'
export const STOCK_VEHICLE_DETAIL = 'vehicle-detail'
export const STOCK_CONGRATULATIONS = 'congratulations'
export const STOCK_TRADEIN = 'tradeIn'
export const STOCK_FUNDING = 'funding'
export const STOCK_FINALIZATION = 'finalization'
export const REDIRECT_TO_STOCK_FUNDING = '/stock/funding'
export const REDIRECT_TO_STOCK_FINALIZATION = '/stock/finalization'

// Theming
export const THEMING = '/theming'
export const THEMING_VIEW_1 = 'view1'
export const THEMING_VIEW_2 = 'view2'
